import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import MapWrapper from "./MapWrapper.js";
import SidePanel from './SidePanel.js';
import Header from './Header';
import MoreInfoBox from "./MoreInfoBox";
import Dialog from "./Dialog.js";

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //count: 0,
      numRounds: 5,
      itemShownInInfoBox: 0,
      showDialog: false,
      process: "guess",
      round: 0,
      isMoreInfoNeeded: false,
      guessPosition: null,
      actualPosition: null,
      distance: -1,
      markerMoved: false,
    };

    this.correctPosition = {};
    this.processGuess = this.processGuess.bind(this);
    this.registerCorrectPosition = this.registerCorrectPosition.bind(this);
    this.displayResult = this.displayResult.bind(this);
    this.nextRound = this.nextRound.bind(this);
    this.displayMoreInfo = this.displayMoreInfo.bind(this);
    this.hideMoreInfo = this.hideMoreInfo.bind(this);
    this.registerMarkerMoved = this.registerMarkerMoved.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
  }

  showDialog() {
    this.setState({showDialog: true});
  }

  hideDialog() {
    this.setState({showDialog: false});
  }

  processGuess(lat, lng) {
    const guessPosition = {
      lat: lat,
      lng: lng,
    };
    this.setState({
      guessPosition: guessPosition,
      actualPosition: this.correctPosition,      
    });
  }

  registerCorrectPosition(item) {
    this.correctPosition = {
      lat: item.lat,
      lng: item.lng,
    };
  }

  displayMoreInfo(round){
    let currItemIndex = this.state.round;
    if(round != null){
      currItemIndex = round
    }
    this.setState({
      isMoreInfoNeeded: true,
      itemShownInInfoBox: currItemIndex,
    })
    const assetID = this.props.gameData[currItemIndex].id;
    const payload = {
        action: "click asset",
        label: assetID,
      }
    this.props.track(payload);
  }

  hideMoreInfo(){
    // console.log('hide more info!');
    this.setState({
      isMoreInfoNeeded: false,
    });
  }

  registerMarkerMoved(){
    this.setState({
      markerMoved:true,
    })
  }

  displayResult(distance, score) {
    this.setState({
      distance: distance,
      score: score,
      process: "result",
    });
    this.props.registerScore(score);
    //also add the current score to the total one.
  }

  nextRound() {
    if(this.state.round < this.state.numRounds-1){
      const nextRound = this.state.round+1
      this.props.registerRound(nextRound);
      this.setState({
        round: nextRound,
        itemShownInInfoBox: nextRound,
        process: "guess",
        actualPosition: null,
        guessPosition: null,
      });
    }
    else{
      this.props.registerEndGame();
      this.setState({
        process: "end"
      });
    }
    
  }

  render() {
    // const { setScreen } = this.props;
    return (
      <div className="w-100 h-100">
        <AnimatePresence>
          {this.state.showDialog && (
            <Dialog
              i18n={this.props.i18n}
              resetGame={this.props.resetGame}
              hideDialog={this.hideDialog}
            />
          )}
        </AnimatePresence>
        <motion.div
          // {`aspect-ratio--object cover bg-custom-dark br-pill fit-cover  ${
          //       showMoreInfo ? "pointer" : null
          //     }`}
          className={`flex flex-row-ns items-center w-100 h-100 overflow-hidden ${
            this.state.process === "end" ? "flex-column" : "flex-column-reverse"
          }`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ ease: "easeOut", duration: 0.8 }}
        >
          <AnimatePresence>
            {this.state.isMoreInfoNeeded && (
              <MoreInfoBox
                i18n={this.props.i18n}
                rtl={this.props.rtl}
                hideMoreInfo={this.hideMoreInfo}
                openLink={this.props.openLink}
                gameData={this.props.gameData}
                round={this.state.round}
                gameProcess={this.state.process}
                isOpen={this.state.isMoreInfoNeeded}
                itemShownInInfoBox={this.state.itemShownInInfoBox}
              />
            )}
          </AnimatePresence>
          <div className="w-60-ns w-100 h-100-ns h-100 relative">
            {this.state.process !== "end" ? (
              <Header
                totalScore={this.props.totalScore}
                round={this.state.round}
                i18n={this.props.i18n}
              />
            ) : null}

            <MapWrapper
              i18n={this.props.i18n}
              track={this.props.track}
              hasGuessedAtLeastOnce={this.props.hasGuessedAtLeastOnce}
              markerMoved={this.state.markerMoved}
              registerMarkerMoved={this.registerMarkerMoved}
              processGuess={this.processGuess}
              actualPosition={this.state.actualPosition}
              displayResult={this.displayResult}
              round={this.state.round}
              isInLine={this.props.isInLine}
              gameData={this.props.gameData}
              process={this.state.process}
              nextRound={this.nextRound}
              numRounds={this.state.numRounds}
              resetGame={this.props.resetGame}
              showDialog={this.showDialog}
              share={this.props.share}
              registerMapsLoaded={this.props.registerMapsLoaded}
            />
          </div>
          <div className="w-40-ns w-100 h-100-ns h-auto sidepanel">
            <SidePanel
              i18n={this.props.i18n}
              openLink={this.props.openLink}
              displayMoreInfo={this.displayMoreInfo}
              resetGame={this.props.resetGame}
              gameData={this.props.gameData}
              round={this.state.round}
              numRounds={this.state.numRounds}
              process={this.state.process}
              distance={this.state.distance}
              score={this.state.score}
              totalScore={this.props.totalScore}
              registerCorrectPosition={this.registerCorrectPosition}
              nextRound={this.nextRound}
              share={this.props.share}
              mapsLoaded={this.props.mapsLoaded}
            />
          </div>
          {/* <button
            onClick={() => {
              setScreen("end");
            }}
          >
            End the game
          </button> */}
        </motion.div>
      </div>
    );
  }
}

export default Game;
